/**
* @description: 上机/落机打卡记录
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch">
                <template #btns>
                    <el-button
                        type="success"
                        icon="Download"
                        @click="exportData()"
                        >{{ t('attendance.exportSummary') }}</el-button
                    >
                    <el-button
                        type="success"
                        icon="Download"
                        @click="mingxiData()"
                        >{{ t('attendance.exportDetail') }}</el-button
                    >
                </template>
            </hc-search>
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :loading="state.loading" :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight"
                :maxPage="maxPage" @pageChange="pageChange" @limitChange="limitChange">
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button class="opBtn" size="small" type="primary" link
                            @click="$refs['detail'].open(scope.row)">{{ t('common.detail') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>

        <Detail ref="detail" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, toRaw } from "vue";
import { ElMessage } from "element-plus";
import Detail from "./components/record-detail.vue";
import { useAttendancePageI18n, t } from '@/composables/useAttendancePageI18n.js';

import { exportExcel } from "@/utils/apiBase"
import { SummaryList } from "@/api/attendance/OTDR.js";
import { pageListApi as userListApi } from "@/api/system/personnel";
const myElementRef = ref();
const searchBox = ref();
const detail = ref();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);

const getUserList = () => {
    const params = JSON.stringify({
        "page": 1,
        "limit": 9999,
        "keywords": "",
        "role_id": 0
    })
    userListApi(params).then(res => {
        searchData[0].children = res.data.map(i => {
            return { label: i.real_name, value: i.real_name }
        })
        getSearch(searchData)
    })
}

const searchData = reactive([
    { label: "", type: "select", value: "", field: 'real_name', children: [] },
    { label: "", type: "month", value: "2025-08", field: 'time' },
]);

const buildColumns = () => ([
    { prop: "id", show: false, label: "ID" },
    { show: true, type: "index", label: t('table.index'), width: 80 },
    { prop: "real_name", show: true, label: t('field.realName') },
    { prop: "mobile", show: true, label: t('field.mobile') },
    { prop: "goToWork", show: true, label: t('attendance.clockDays') },
    { prop: "otDay", show: true, label: t('attendance.otDays') },
    { prop: "otTime", show: true, label: t('attendance.otHours') },
    { prop: "zhiDay", show: true, label: t('attendance.zhiDays') },
    { prop: "zhiTime", show: true, label: t('attendance.zhiHours') },
    { prop: "tongxiaoDay", show: true, label: t('attendance.tongxiaoDays') },
    { prop: "nightShiftDay", show: true, label: t('attendance.nightShiftDays') },
    { prop: "chiday", show: true, label: t('attendance.lateCount') },
    { prop: "zaotui", show: true, label: t('attendance.earlyLeaveCount') },
]);

const applyLabels = () => {
    searchData[0].label = t('field.realName');
    searchData[1].label = t('common.startTime');
    state.column = buildColumns();
    tableHeaderFn();
};

useAttendancePageI18n(applyLabels);

const state = reactive({
	loading: false,
    title: "",
    column: buildColumns(),
    offsetHeight: 0,
    tableHeader: [],
    tableData: []
});

const init = () => {
    const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      let yue=month.toString().padStart(2, '0');
      searchData[1].value=year+"-"+yue;
    getUserList()
};

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {
    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {
    limit.value = currentLimit;
    getSearch(searchData)
}

onMounted(() => {
    try {
        applyLabels();
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

const getSearch = (params) => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? []
    console.log(timeData)
    const requestParams = JSON.stringify({
        "real_name": searchData[0].value ?? '',
        "time": timeData ?? '',
        "page": page.value,
        "limit": limit.value
    })
    SummaryList(requestParams).then(res => {
        maxPage.value = res?.maxPage ?? 0;
      state.tableData = res?.data?.map(item => {
        return {
         ...item,
        }
      })
    })
};

const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};

const buildSummaryExportParams = () => {
    const timeData = toRaw(searchData.filter(i => i.field === 'time')[0] ?? {}).value ?? ''
    if (!timeData) {
        return null
    }
    const params = { time: timeData }
    const realName = searchData[0].value ?? ''
    if (realName) {
        params.real_name = realName
    }
    return params
}

const exportData = async () => {
    const params = buildSummaryExportParams()
    if (!params) {
        ElMessage.warning(t('attendance.selectMonth'))
        return
    }
    const { ok, msg } = await exportExcel('Excel/huiAccountExcel', params, '打卡汇总.xls')
    if (!ok) {
        ElMessage.error(msg || t('attendance.exportFailed'))
    }
}

const mingxiData = async () => {
    const params = buildSummaryExportParams()
    if (!params) {
        ElMessage.warning(t('attendance.selectMonth'))
        return
    }
    const { ok, msg } = await exportExcel('Excel/fenAccountExcel', params, '打卡分析汇总.xls')
    if (!ok) {
        ElMessage.error(msg || t('attendance.exportFailed'))
    }
}


</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}
</style>
